export const IconFavoriteStarEmpty: {
  name: 'icon_favorite_star_empty-de929ae8d916'
} = {
  name: 'icon_favorite_star_empty-de929ae8d916'
}
